import React from 'react';
import BackgroundCheck from '../../components/BackgroundCheck';
import { useI18n } from '../../context/I18nContext';

export default function BackgroundCheckPage() {
  const { t } = useI18n();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">
          {t('background_check', 'Background Check')}
        </h1>
        <p className="text-slate-600">
          Complete your background verification to start accepting rides
        </p>
      </div>
      
      <div className="max-w-2xl">
        <BackgroundCheck />
      </div>
    </div>
  );
}
